import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import MiniHeader from '../../../../UI/MiniHeader'
import Loading from '../../../../UI/Loading'
import http from '../../../../shared/http'
import { TApi } from '../../../../shared/const'
import { EVENT_LABELS } from '../CompanyProfile/components/LogTab'

import styles from './style.module.scss'
import { formatVienna } from '../../../../shared/datetime'

/**
 * Nachrichten der Verwaltung zum eigenen bzw. betreuten Unternehmen.
 *
 * Gegenstueck zum Reiter „Log-Verlauf & Kommentare" im Firmenprofil: hier
 * stehen nur die Kommentare, die ausdruecklich an die eigene Rolle gerichtet
 * waren. Die interne Benachrichtigung verweist hierher, damit eine Nachricht
 * nicht nur als Einzelmeldung ankommt, sondern im Zusammenhang lesbar bleibt.
 */
export default function CompanyMessages() {
	const { t } = useTranslation()
	const { id } = useParams()
	const [entries, setEntries] = useState(null)
	const [companyName, setCompanyName] = useState('')

	useEffect(() => {
		http.get(TApi.COMMON_COMPANY_LOG(id))
			.then(({ data }) => {
				setCompanyName(data?.company?.name || '')
				setEntries(data?.entries || [])
			})
			.catch(() => setEntries([])) // Meldung kommt aus shared/http
	}, [id])

	// Die Junior Company steht in der Ueberschrift: Eine Lehrkraft betreut
	// mehrere, und die Seite ist sonst nicht zuzuordnen - weder aus der
	// Mitteilung heraus noch beim spaeteren Wiederaufrufen.
	const title = companyName
		? t('Messages from the administration about {{val1}}', { val1: companyName })
		: t('Messages from the administration')

	return (
		<div className={styles.root}>
			<MiniHeader title={title} bg="#f8faff" />

			<div className={styles.main}>
				{entries === null && <Loading />}
				{entries?.length === 0 && <div className={styles.empty}>{t('No messages yet')}</div>}
				{!!entries?.length && (
					<ol className={styles.list}>
						{entries.map(entry => (
							<li key={entry.id} className={styles.item}>
								<div className={styles.head}>
									<span className={styles.author}>{entry.authorName || t('Administration')}</span>
									<span className={styles.date}>
										{formatVienna(entry.createdAt, 'dd.MM.yyyy HH:mm')}
									</span>
								</div>
								{/* Seit #230 stehen hier auch Ereignisse, die ausdrücklich an
								    die Schule gehen (geänderte Branche, Freigabe zur
								    Überarbeitung) — mit ihrem Namen über dem Text. */}
								{entry.type === 'EVENT' && (
									<strong className={styles.eventTitle}>
										{t(EVENT_LABELS[entry.eventKey] || entry.eventKey)}
									</strong>
								)}
								<p className={styles.text}>{entry.message}</p>
							</li>
						))}
					</ol>
				)}
			</div>
		</div>
	)
}
